<template>
  <section id="about" v-navItem class="w-full h-auto pt-10">
    <div
      class="
        w-full
        flex flex-col
        justify-center
        md:flex-row md:justify-between
        items-center
        px-10
        md:px-36
        lg:px-64
        py-10
      "
    >
      <icon-link
        v-for="(iconLinkItem, i) in iconLinkItems"
        :key="i"
        :href="iconLinkItem.href"
        :icon="iconLinkItem.icon"
        :text="iconLinkItem.text"
        class="w-full mb-7 md:mb-0 md:w-1/4"
      />
    </div>

    <div
      class="
        w-full
        flex flex-col
        justify-center
        md:flex-row md:justify-between
        items-center
        py-10
        px-10
        md:px-36
        lg:px-64
      "
    >
      <div class="md:w-1/2 md:mr-5">
        <div class="md:w-1/6">
          <heading text="About Us" />
        </div>

        <br />
        <p class="text-xl md:text-4xl capitalize">
          Empowering girls to shape their own futures in Malawi
        </p>

        <br />
        <p class="text-justify">
          Welcome to Community AIDS Responses-CARE (CARE), a dynamic youth-led organization 
          working at the heart of communities across Malawi. We're passionate about transforming 
          lives by championing girls' rights and breaking down the barriers that prevent young 
          women from reaching their full potential. As a national Civil Society Organization, 
          we combine local understanding with national impact to create lasting change.
        </p>

        <br />
        <p class="text-justify">
          From our headquarters in Lilongwe, we reach deep into rural villages across 
          Lilongwe, Mzimba, Dedza and Dowa districts where the need is greatest. In these 
          communities, child marriage remains a devastating reality—robbing young girls of 
          their childhood, education, and basic human rights. We stand against this harmful 
          practice, fighting to ensure every girl can choose her own path, live free from 
          violence and coercion, and access the education she deserves. Together with local 
          partners, we're creating a future where girls' rights are respected, protected, 
          and celebrated. CARE is a registered Charity Number: TR/INC: 6540.
        </p>
      </div>

      <div class="w-1/2 object-cover hidden md:flex md:justify-center md:items-center">
        <img src="/images/3081629.jpg" alt="" class="">
      </div>
    </div>

    <div
      class="
        w-full
        bg-gray-100
        py-10
        px-10
        md:px-36
        lg:px-64
        flex flex-col
        justify-center
        md:flex-row md:justify-between
        items-center
      "
    >
      <div class="md:w-1/2">
        <h4 class="font-bold text-xl mb-3">Our Mission</h4>
        <p>
          We're on a mission to empower every girl to claim her rights, choose her own future, 
          and break free from child marriage. Through community-led action and powerful advocacy, 
          we're dismantling barriers to education and reproductive health, ensuring girls can 
          thrive, not just survive.
        </p>
      </div>

      <div class="mt-7 md:mt-0 md:w-2/5">
        <h4 class="font-bold text-xl mb-3">Our Vision</h4>
        <p>
          We envision a Malawi where every girl grows up safe, educated, and empowered to 
          dream big. A future where communities protect their daughters, celebrate their potential, 
          and stand together to end child marriage forever. Together, we're building a world 
          where girls' rights are human rights.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import Heading from "./heading.vue";
import IconLink from "./IconLink.vue";
export default {
  components: { IconLink, Heading },
  setup() {
    const iconLinkItems = [
      {
        icon: "handshake-angle",
        text: "volunteer",
        href: "#donate",
      },
      {
        icon: "donate",
        text: "Donate",
        href: "#donate",
      },
      {
        icon: "lightbulb",
        text: "Inspire",
        href: "#donate",
      },
    ];

    return { iconLinkItems };
  },
};
</script>

<style>
</style>